import { CartItem } from '@/types/cart.types';

export function getCartItemPrice(item: CartItem): number {
  return item.discountedPrice ?? item.price ?? 0;
}

export function getCartTotal(items: CartItem[]): number {
  return items.reduce((total, item) => total + getCartItemPrice(item), 0);
}
